import React, { useCallback, useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { ConfirmDialog } from "../../components/admin/payment-center/ConfirmDialog";
import { GuideMetrics } from "../../components/admin/wa-portal-guide/GuideMetrics";
import { HandoffQueue } from "../../components/admin/wa-portal-guide/HandoffQueue";
import { GuideSimulator } from "../../components/admin/wa-portal-guide/GuideSimulator";

export default function AdminWaPortalGuide() {
  const [st, setSt] = useState(null);
  const [handoffs, setHandoffs] = useState([]);
  const [pending, setPending] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    const [s, h] = await Promise.all([api.get("/admin/wa-portal-guide/status"), api.get("/admin/wa-portal-guide/handoffs")]);
    setSt(s.data); setHandoffs(h.data);
  }, []);
  useEffect(() => { load().catch(() => toast.error("Falha ao carregar o Guia do Portal")); }, [load]);

  const applyMode = async (typed) => {
    setBusy(true);
    try { await api.post("/admin/wa-portal-guide/mode", { mode: pending, confirm_text: typed }); toast.success("Modo atualizado"); await load(); return true; }
    catch (e) { toast.error(e?.response?.data?.detail || "Alteração recusada"); return false; }
    finally { setBusy(false); }
  };
  const toggleAvail = async () => {
    const next = !st.config.portal_available;
    if (!window.confirm(next ? "Marcar o Portal como disponível?" : "Marcar o Portal em instabilidade? A IA passará a avisar as clientes e abrirá pendências na fila.")) return;
    try { await api.post("/admin/wa-portal-guide/portal-availability", { available: next }); toast.success("Disponibilidade atualizada"); await load(); }
    catch { toast.error("Não foi possível alterar"); }
  };
  const resolve = async (id) => {
    try { await api.post(`/admin/wa-portal-guide/handoffs/${id}/resolve`); await load(); } catch { toast.error("Não foi possível resolver"); }
  };

  if (!st) return <div className="p-6 text-sm" data-testid="wpg-loading">Carregando...</div>;
  const on = st.config.mode === "ALL";
  return (
    <div className="space-y-6" data-testid="wa-portal-guide-page">
      <div>
        <div className="text-[10px] tracking-[0.2em] uppercase text-[#5C5A57]">WhatsApp oficial</div>
        <h1 className="font-display text-4xl font-bold tracking-tight mt-1">IA → Portal da Cliente</h1>
        <p className="text-sm text-[#5C5A57] mt-2 max-w-2xl">Consultas financeiras no WhatsApp são orientadas ao Portal ({st.portal_url}). A IA nunca informa valores, compras ou parcelas pelo WhatsApp. Independente do módulo Oportunidades.</p>
      </div>
      <section className="border border-[#EBE5DF] bg-white p-6 flex flex-wrap items-center gap-4" data-testid="wpg-mode-section">
        <div className="flex-1 min-w-[220px]">
          <div className="text-sm">Modo atual: <b data-testid="wpg-mode-value">{on ? "ALL (todas as clientes)" : "OFF (desligado)"}</b></div>
          <div className="text-xs text-[#5C5A57] mt-1">Sem fase piloto. A ativação é auditada.</div>
        </div>
        <button onClick={() => setPending(on ? "OFF" : "ALL")} className={`px-4 py-2 text-sm text-white ${on ? "bg-[#8A1C1C]" : "bg-[#4C2380]"}`} data-testid="wpg-mode-toggle">
          {on ? "Desligar" : "Ativar para todas"}</button>
        <button onClick={toggleAvail} className="border px-4 py-2 text-sm" data-testid="wpg-availability-toggle">
          Portal: {st.config.portal_available ? "disponível" : "em instabilidade"} (alterar)</button>
      </section>
      <GuideMetrics m={st.metrics} />
      <HandoffQueue items={handoffs} onResolve={resolve} />
      <GuideSimulator />
      <ConfirmDialog open={!!pending} onClose={() => setPending(null)} busy={busy} withReason={false} onConfirm={applyMode}
        title={pending === "ALL" ? "Ativar o Guia do Portal para todas as clientes" : "Desligar o Guia do Portal"}
        description="A IA passará a orientar as consultas financeiras ao Portal da Cliente." confirmText={pending ? st.confirm_texts[pending] : ""} />
    </div>
  );
}
